import { render, staticRenderFns } from "./index.vue?vue&type=template&id=0bbb53ac&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=0bbb53ac&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bbb53ac",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/actions-runner/_work/treasurenet-tnservices-producerPlatform-fe/treasurenet-tnservices-producerPlatform-fe/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0bbb53ac')) {
      api.createRecord('0bbb53ac', component.options)
    } else {
      api.reload('0bbb53ac', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=0bbb53ac&scoped=true", function () {
      api.rerender('0bbb53ac', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/BigNumber/index.vue"
export default component.exports